module.exports = __webpack_public_path__ + "5a8ebbd2a602581d2fa3cb4cb01eada3.svg";